import { useEffect, useState } from 'react';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import { useContext } from 'react';
import { store } from 'components/Store';
import { useParams } from 'react-router';

function useGetEngagementStatisticsItem() {
  const params = useParams();
  let { itemId, type } = params;
  const [item, setItem] = useState(null);
  const { generalApiCall } = useGeneralApiCall();

  const globalState = useContext(store);
  const { dispatch } = globalState;

  const getEngagementStatisticsItem = async (source) => {
    const pathname = `/api/user-generated-content/${type === 'policy-asks' ? 'policy-ask' : type}/${itemId}`;
    const method = 'get';
    const results = await generalApiCall({
      pathname,
      method,
      needsAuthentication: true,
      notShowErrorMessage: true,
      requestSource: source,
    });
    if (results) {
      setItem(results);
      dispatch({
        type: 'MODIFY_SECTION',
        parameter: 'engagementStatisticItem',
        value: results,
      });
    }
  };

  useEffect(() => {
    const source = new AbortController();
    if (itemId && type) {
      getEngagementStatisticsItem(source);
    }
    return () => {
      source.abort('Engagement statistics api call canceled by the user');
    };
  }, [itemId, type]);
  return { item };
}

export default useGetEngagementStatisticsItem;
